import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Copy } from "lucide-react";
import { toast } from "sonner";

interface SuccessModalProps {
  open: boolean;
  data: any;
  onClose: () => void;
  onCreateAnother: () => void;
}

export function SuccessModal({ open, data, onClose, onCreateAnother }: SuccessModalProps) {
  const copyCredentials = () => {
    const text = `E-mail: ${data.credentials?.email}\nSenha: ${data.credentials?.password}`;
    navigator.clipboard.writeText(text);
    toast.success("Credenciais copiadas!");
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-green-600">
            <CheckCircle2 className="h-6 w-6" />
            Tenant Demo Criada com Sucesso!
          </DialogTitle>
          <DialogDescription>
            A tenant foi criada e está pronta para uso
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="p-4 bg-muted rounded-lg space-y-2">
            <h4 className="font-semibold">Credenciais de Acesso:</h4>
            <div className="space-y-1 text-sm">
              <div>
                <span className="text-muted-foreground">E-mail:</span>
                <span className="ml-2 font-mono">{data.credentials?.email}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Senha:</span>
                <span className="ml-2 font-mono">{data.credentials?.password}</span>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={copyCredentials}
              className="w-full mt-2"
            >
              <Copy className="h-4 w-4 mr-2" />
              Copiar Credenciais
            </Button>
          </div>

          <div className="p-4 bg-muted rounded-lg space-y-2">
            <h4 className="font-semibold">Resumo da Tenant:</h4>
            <div className="space-y-1 text-sm">
              <div>
                <span className="text-muted-foreground">Empresa:</span>
                <span className="ml-2">{data.summary?.tenant}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Plano:</span>
                <span className="ml-2">{data.summary?.plan}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Produtos:</span>
                <span className="ml-2">{data.summary?.products}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Clientes:</span>
                <span className="ml-2">{data.summary?.customers}</span>
              </div>
              <div>
                <span className="text-muted-foreground">Meses de métricas:</span>
                <span className="ml-2">{data.summary?.metricsMonths}</span>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCreateAnother}>
            Criar Outra
          </Button>
          <Button onClick={onClose}>Fechar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
